import { render, staticRenderFns } from "./MenuArea.vue?vue&type=template&id=13e8b612&scoped=true&"
import script from "./MenuArea.vue?vue&type=script&lang=js&"
export * from "./MenuArea.vue?vue&type=script&lang=js&"
import style0 from "./MenuArea.vue?vue&type=style&index=0&id=13e8b612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e8b612",
  null
  
)

export default component.exports